
import Vue from 'vue';
import Component from 'vue-class-component';
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
import {
    Gender,
    PersonalInfoActions,
    PersonalInfoModel,
    PersonalInfoOptions, ResultError,
    UpdatePersonalInfoRequest,
} from "@/api-client";
import { Prop } from "vue-property-decorator";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import CheckboxInput from "@/features/shared/components/CheckboxInput.vue";
import toasts from "@/components/Toasts";

@Component({
    components: {
        HeadingGroup,
        LabelOptional,
        CheckboxInput
    },
})
export default class PersonMainInfo extends Vue {
    @Prop({ required: true })
    validationErrors!: ResultError;

    @Prop({ required: true })
    model!: PersonalInfoModel;

    @Prop({ required: true })
    updateModel!: UpdatePersonalInfoRequest;

    @Prop({ required: true })
    options!: PersonalInfoOptions;

    @Prop({ required: true })
    isInfoLocked!: boolean;

    @Prop({ required: true })
    availableActions!: PersonalInfoActions;

    created() {
        this.$watch(() => this.updateModel.withoutNationality, () => {
            this.updateModel.nationality = null;
        });
        this.$watch(() => this.updateModel.gender, () => {
            if (this.validateGender() == false) {
                toasts.warning(this.$ls.Seafarer_Validation_PersonalCodeGenderDoesNotMatchProfileGender);
            }
        });
    }

    getNationalityName(countryCode: string | null) {
        if (!countryCode) return this.$ls.Global_Text_Stateless;
        return this.getCountryNameByCode(countryCode);
    }

    getCountryNameByCode(countryCode: string) {
        return this.options.countries.filter(c => c.letterCode === countryCode)[0]?.name || "-";
    }

    editInfo() {
        this.$emit("edit-info-clicked");
    }

    getGender(gender: Gender) {
        switch (gender) {
            case Gender.Male:
                return this.$ls.Global_Gender_Male;
            case Gender.Female:
                return this.$ls.Global_Gender_Female;
            default:
                return "-";
        }
    }
    validateGender() {
        if (this.model.personalCode) {
            switch (parseInt(this.model.personalCode[0]) % 2) {
                case 0:
                    return this.updateModel.gender == Gender.Female;
                case 1:
                    return this.updateModel.gender == Gender.Male;
            }
        }
    }

    genderOptions = [
        { text: this.$ls.Global_Gender_Male, value: Gender.Male },
        { text: this.$ls.Global_Gender_Female, value: Gender.Female },
    ];
}
